export default __webpack_public_path__ + "static/media/a023-startup5-en-short.30625fb7.png";